import styled from '@emotion/styled'
import { SectionEmptyState } from 'components/sectionEmptyState/SectionEmptyState'

export const SMemoryGalleryPlaceholder = styled(SectionEmptyState)`
  margin-top: 1rem;
`
